import { Card as HygraphCardProps, CardStyles } from '@/lib/types';

import Card from '@/components/card';
import { HorizontalImageTextCard } from '@/components/horizontal-image-text-card';

import cardTransformer from '@/hygraph/transformers/card.transformer';

export default function CardRenderer(
  props: HygraphCardProps & { isInSidebar?: boolean }
) {
  const cardProps = cardTransformer(props);
  if (props.cardStyle === CardStyles.HorizontalImageText) {
    return <HorizontalImageTextCard {...cardProps} />;
  }

  return <Card {...cardProps} />;
}
